import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IIssueEnglishIqHandoffV1Request } from './issue-english-iq-handoff-v1-request';
import type { IIssueEnglishIqHandoffV1Response } from './issue-english-iq-handoff-v1-response';
import { issueEnglishIqHandoffV1ResponseSchema } from './issue-english-iq-handoff-v1-response';

export async function issueEnglishIqHandoffV1Api(
  body: IIssueEnglishIqHandoffV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IIssueEnglishIqHandoffV1Response>> {
  return postRequest<IIssueEnglishIqHandoffV1Response>({
    body,
    options,
    path: '/english-iq/handoff/v1',
    schema: issueEnglishIqHandoffV1ResponseSchema,
  });
}
